<template>
  <div class="aboutHome">
    <baseBg bgUrl="aboutbg"></baseBg>
    <div class="aboutHomeNav w-main">
      <span :class="{ spanAct: pageType === 'page1' }" @click="toPage('page1')">
        学会简介
      </span>
      <span :class="{ spanAct: pageType === 'page2' }" @click="toPage('page2')">
        学会荣誉
      </span>
      <span :class="{ spanAct: pageType === 'page3' }" @click="toPage('page3')">
        大事记
      </span>
      <span :class="{ spanAct: pageType === 'page4' }" @click="toPage('page4')">
        理事会成员
      </span>
      <span :class="{ spanAct: pageType === 'page5' }" @click="toPage('page5')">
        学会章程
      </span>
      <span :class="{ spanAct: pageType === 'page6' }" @click="toPage('page6')">
        联系我们
      </span>
    </div>
    <div class="line w-main"></div>
    <div class="he50"></div>
    <div class="he40"></div>
    <component :is="pageType"></component>
    <div class="he50"></div>
    <div class="he50"></div>
  </div>
</template>

<script>
import baseBg from "@/components/pc/base/bg.vue";
import page1 from "./pages/page1";
import page2 from "./pages/page2";
import page3 from "./pages/page3";
import page4 from "./pages/page4";
import page5 from "./pages/page5";
import page6 from "./pages/page6";
export default {
  data() {
    return {
      pageType: "page1"
    };
  },
  components: {
    baseBg,
    page1,
    page2,
    page3,
    page4,
    page5,
    page6
  },
  watch: {
    $route(newValue) {
      this.toPage(newValue.query.pages);
    }
  },
  mounted() {
    this.toPage(this.$route.query.pages);
  },
  methods: {
    toPage(val) {
      if (val) {
        this.pageType = val;
      } else {
        this.pageType = "page1";
      }
    }
  }
};
</script>

<style lang="less">
.aboutHome {
  .aboutHomeNav {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    span {
      display: inline-block;
      margin: 0 30px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      color: rgba(52, 52, 52, 1);
      cursor: pointer;
    }
    .spanAct {
      color: rgba(108, 45, 102, 1);
      border-bottom: 2px solid #6c2c66;
    }
  }
  .line {
    height: 1px;
    background: rgba(235, 235, 235, 1);
  }
}
</style>
